var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50285 0.252319C7.54236 0.284317 7.58023 0.321113 7.61645 0.35951L13.7147 7.02454C13.8577 7.17878 13.9511 7.37031 13.9835 7.57553C14.0159 7.78074 13.9858 7.99068 13.8969 8.17946C13.8079 8.36824 13.6641 8.52762 13.4832 8.63795C13.3022 8.74829 13.0919 8.80475 12.8783 8.80039L1.08522 8.65641C0.877053 8.65402 0.673875 8.59419 0.499368 8.48389C0.32486 8.37359 0.186212 8.21736 0.0995874 8.03341C0.0129624 7.84946 -0.0180706 7.64537 0.0101054 7.44494C0.0382815 7.24451 0.124506 7.05599 0.258727 6.90135L5.9503 0.377109C6.13933 0.161316 6.40861 0.0270437 6.69925 0.0036585C6.98988 -0.0197267 7.27822 0.069678 7.5012 0.252319H7.50285Z",
    fill: "#363A44"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_up.ad1c15b3f6ba9f59cfb31de458d30b84.svg";